export default __webpack_public_path__ + "static/media/LockIcon.61295f34.svg";